import { axios } from '@/services/axios';

const unassignTCAPUser = async ({ tcapUserId, platformUserId, scope }) => {
    const res = await axios.post(
        `/TcapUser/${tcapUserId}/PlatformUser/${platformUserId}/Unassign`,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};

export default unassignTCAPUser;
